import React from 'react';
import {
  Box,
  Chip,
  TextField,
  FormHelperText,
  IconButton
} from '@mui/material';
import { Add as AddIcon, Cancel as CancelIcon } from '@mui/icons-material';

const TagsInput = ({ tags, onAddTag, onRemoveTag, error, helperText, required = false }) => {
  const [inputValue, setInputValue] = React.useState('');

  const handleAddTag = () => {
    if (inputValue.trim() && !tags.includes(inputValue.trim())) {
      onAddTag(inputValue.trim());
      setInputValue('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1}>
        <TextField
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          label={required ? "Tags *" : "Tags"}
          placeholder="Add a tag and press Enter"
          error={error}
          fullWidth
          sx={{
            '& .MuiFormHelperText-root': {
              marginLeft: 0
            }
          }}
        />
        <IconButton 
          onClick={handleAddTag} 
          color="primary"
          sx={{ mt: 1 }}
        >
          <AddIcon />
        </IconButton>
      </Box>
      
      {helperText && (
        <FormHelperText error={error} sx={{ mt: 1, ml: 0 }}>
          {helperText}
        </FormHelperText>
      )}
      
      <Box mt={1} display="flex" flexWrap="wrap" gap={0.5}>
        {tags.map((tag, index) => (
          <Chip
            key={index}
            label={tag}
            onDelete={() => onRemoveTag(index)}
            deleteIcon={<CancelIcon />}
            color="primary"
            variant="outlined"
          />
        ))}
      </Box>
    </Box>
  );
};

export default TagsInput;

// import React from 'react';
// import {
//   TextField,
//   Box,
//   Chip
// } from '@mui/material';

// const TagsInput = ({ tags, onAddTag, onRemoveTag, label = "Add Tags", placeholder = "Press enter to add tag" }) => {
//   const handleKeyDown = (event) => {
//     if (event.key === 'Enter' && event.target.value.trim()) {
//       onAddTag(event.target.value.trim());
//       event.target.value = '';
//     }
//   };

//   return (
//     <Box mt={3}>
//       <TextField
//         fullWidth
//         label={label}
//         margin="normal"
//         placeholder={placeholder}
//         onKeyDown={handleKeyDown}
//         helperText="Add relevant tags to help categorize your value pack"
//       />
//       <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
//         {tags?.map((tag, index) => (
//           <Chip
//             key={index}
//             label={tag}
//             onDelete={() => onRemoveTag(index)}
//             color="primary"
//             variant="outlined"
//           />
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default TagsInput;